<template>
  <div>
  <b-card v-if="isNotEmpty" class="no-border">
    <b-form>
      <div class="form-group flex-inline-form-md">
        <b-input-group class="fill-width">
          <b-input-group-text slot="prepend">
            <i class="fa fa-search"></i>
          </b-input-group-text>
          <b-form-input type="text" placeholder="Search order by order number" v-model="searchQuery"></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-button @click="createOrder()" variant="success" class="w-100">New order &nbsp;<i class="fa fa-plus"></i></b-button>
        </b-input-group>
      </div>
    </b-form>
    <div
      v-if="isFiltered"
      @click="onRemoveFilter"
      class="remove--filter mb-2">
      <i class="fa fa-window-close" aria-hidden="true"></i>
      <span>Clear current filters and sorts.</span>
    </div>
    <b-card>
      <template slot="header">
        <!-- <ui-multiselect
          @select-option="onSelectCompany"
          :initSelect="initSelectCompany"
          :options="companiesData"
          :searchable="true"
          :className="'pull-right ml-2'"
          :selectLabel="'Company'"
          :title="'Filter by company'"
          :placeholder="'Search company'"
          :label="'name'"></ui-multiselect>
        <ui-multiselect
          @select-option="onSelectCustomer"
          :initSelect="initSelectCustomer"
          :options="customersData"
          :searchable="true"
          :className="'pull-right ml-2'"
          :selectLabel="'Customer'"
          :title="'Filter by customer'"
          :placeholder="'Search customer'"
          :label="'name'"></ui-multiselect> -->
        <ui-multiselect
          @select-option="onSelectDestination"
          :initSelect="initSelectDestination"
          :options="destinationList"
          :searchable="true"
          :className="'pull-right ml-2'"
          :selectLabel="'Destination'"
          :title="'Filter by destination'"
          :placeholder="'Search destination'"
          :label="'name'"></ui-multiselect>
        <ui-multiselect
          @select-option="onSelectSort"
          :initSelect="initSelectSort"
          :options="sortOptions"
          :className="'pull-right ml-2'"
          :selectLabel="'Sort'"
          :title="'Sort by'"
          :label="'name'"></ui-multiselect>
      </template>
      <b-table striped responsive
        :items="(isFetched ? table.items : dataBeforeLoad)"
        :fields="table.fields"
        :class="isLoading ? 'show__blur' : ''">
        <template #cell(number)="data">
          <router-link :to="`/shipment_md/orders/${data.item.id}`">{{data.value}}</router-link>
        </template>
        <template #cell(shipment)="data">
          <router-link :to="`/shipment_md/shipments/${getShipmentId(data.item.shipment)}`">{{getShipmentNumber(data.item.shipment)}}</router-link>
        </template>
        <template #cell(customer)="data">
          <div>
            <div>{{data.value.name}}</div>
            <template v-if="data.value.address">
              <div class="small text-muted">{{data.value.address.address1}}</div>
              <div class="small text-muted">{{data.value.address.city}} {{data.value.address.state}} {{data.value.address.zip_code}}</div>
              <div v-if="!data.item.destination" class="text-danger small">
                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                Invalid destination
              </div>
            </template>
          </div>
        </template>
        <template #cell(location)="data">
          <div v-if="data.item.destination">
            <div>{{data.item.destination.code}}</div>
            <div class="small">{{data.item.destination.name}}</div>
          </div>
        </template>
        <template #cell(created_at)="data">{{formatDateTime(data.value)}}</template>
        <template #cell(delivery_date)="data">{{formatDate(data.value)}}</template>
        <template #cell(time_in)="data">
          <div v-b-tooltip.hover title="Time In GPS" class="text-muted small">
            <i class="fa fa-truck"></i>
            {{formatDateTime(getTimeIn(data.item.metadata)) || 'Unknown'}}
          </div>
          <div v-if="!isCopp" v-b-tooltip.hover title="Time In App" class="text-muted small">
            <i class="fa fa-android"></i>
            {{formatDateTime(getTimeIn(data.item.metadata, 'app')) || 'Unknown'}}
          </div>
        </template>
        <template #cell(time_out)="data">
          <div v-b-tooltip.hover title="Time Out GPS" class="text-muted small">
            <i class="fa fa-truck"></i>
            {{formatDateTime(getTimeOut(data.item.metadata)) || 'Unknown'}}
          </div>
          <div v-if="!isCopp" v-b-tooltip.hover title="Time Out App" class="text-muted small">
            <i class="fa fa-android"></i>
            {{formatDateTime(getTimeOut(data.item.metadata, 'app')) || 'Unknown'}}
          </div>
        </template>
        <template #cell(duration)="data">
          <div v-if="getDuration(data.item.metadata)" v-b-tooltip.hover title="Duration GPS" class="text-muted small">
            <i class="fa fa-truck"></i>
            {{getDuration(data.item.metadata)}}
          </div>
          <div v-if="getDuration(data.item.metadata, 'app')" v-b-tooltip.hover title="Duration App" class="text-muted small">
            <i class="fa fa-android"></i>
            {{getDuration(data.item.metadata, 'app')}}
          </div>
        </template>
        <template #cell(confirmed_by)="data">
          <div v-if="!isObjectEmpty(getConfirmation(data.item))">
            <div class="text-success"><i class="fa fa-user" aria-hidden="true"></i>
              {{getConfirmation(data.item).name}}
            </div>
            <div class="text-muted small"><i class="fa fa-calendar" aria-hidden="true"></i>
              {{formatDateTime(getConfirmation(data.item).created_at)}}
            </div>
          </div>
          <div v-else class="text-muted">Unconfirmed</div>
        </template>
        <template #cell(signature)="data">
          <img class="table-confirm-signature"
            v-if="!isObjectEmpty(getConfirmation(data.item)) && checkHasSignature(data.item)"
            :src="createSignature(getConfirmation(data.item).signature)"
            alt="signature">
        </template>
        <template #cell(cancelled)="data">
          <span v-if="get(data, 'item.metadata.abort')" class="text-danger">
            {{get(data, 'item.metadata.abort.reason')}}
          </span>
          <span v-if="get(data, 'item.metadata.rejected')" class="text-danger">
            <div class="text-muted"><i class="fa fa-user" aria-hidden="true"></i>
              {{get(data, 'item.metadata.rejected.name')}}
            </div>
            {{get(data, 'item.metadata.rejected.reason')}}
          </span>
        </template>
        <template #cell(info)="data">
          <span v-if="get(data, 'item.metadata.abort')" class="text-danger">
            {{get(data, 'item.metadata.abort.reason')}}
          </span>
          <span v-else-if="get(data, 'item.metadata.rejected')" class="text-danger">
            <div class="text-muted"><i class="fa fa-user" aria-hidden="true"></i>
              {{get(data, 'item.metadata.rejected.name')}}
            </div>
            {{get(data, 'item.metadata.rejected.reason')}}
          </span>
          <span v-else-if="!isObjectEmpty(getConfirmation(data.item))">
            {{ getConfirmation(data.item).metadata.notes }}
          </span>
        </template>
      </b-table>
      <div
        class="show__loading"
        v-if="isLoading"
        :style="`height: ${dataBeforeLoad.length*80+50}px;`">
        <i
          class="fa fa-spinner fa-pulse fa-4x fa-modify"
          alt="Loading"
          :style="`margin-top: ${(dataBeforeLoad.length*80+50)/2}px;`"></i>
      </div>
    </b-card>
    <nav aria-label="Shipment pagination" class="pull-right">
      <ul class="pagination">
        <li class="page-item" :class="{disabled: prevDisabled}">
          <a class="page-link" href="#" @click.prevent="prevPage()"><span aria-hidden="true">&laquo;</span> Previous</a>
        </li>
        <li class="page-item" :class="{disabled: nextDisabled}">
          <a class="page-link" href="#" @click.prevent="nextPage()">Next <span aria-hidden="true">&raquo;</span></a>
        </li>
      </ul>
    </nav>
  </b-card>
  <b-alert show v-else-if="loaded">There's no order data.</b-alert>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import {
  throttle, last, uniqBy, concat, isEmpty,
  get, filter, isEqual, isObject, omit,
  isString, cloneDeep, head,
} from 'lodash';

import UiMultiselect from '@/components/UiMultiselect';

export default {
  name: 'order_list',
  mixins: [dateMixin],
  components: {
    UiMultiselect,
  },
  data() {
    return {
      companiesData: [],
      customersData: [],
      loaded: false,
      searchQuery: '',
      filterType: 'ACTIVE',
      lastData: null,
      lastDataAr: [],
      destinationList: [],
      dataBeforeLoad: [],
      selectedCompany: null,
      initSelectCompany: null,
      selectedCustomer: null,
      initSelectCustomer: null,
      selectedDestination: null,
      initSelectDestination: null,
      currentSort: null,
      initSelectSort: null,
      sortOptions: [
        { id: 1, value: 'NUMBER.ASC', name: 'Number 0-9' },
        { id: 2, value: 'NUMBER.DESC', name: 'Number 9-0' },
        { id: 3, value: 'ID.DESC', name: 'Last Created' },
        { id: 4, value: 'ID.ASC', name: 'Oldest Created' },
      ],
      table: {
        fields: [
          'number',
          'shipment',
          'customer',
          'delivery_date',
          'time_in',
          'time_out',
          'duration',
          'confirmed_by',
          'signature',
          'cancelled',
        ],
        items: [],
      },
      sortType: null,
    };
  },
  created() {
    if (this.isCopp) {
      this.table.fields = [
        'number',
        'location',
        'created_at',
        'time_in',
        'time_out',
        'duration',
        'confirmed_by',
        'info',
      ];
    }
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'orders', name: 'Orders' },
    ]);
    this.$store.commit('shipment_md/orders/CLEAR_QUERY');
    this.$store.dispatch('shipment_md/orders/LOAD_LOCATIONS').then(() => {
      this.destinationList = this.locations;
    });
    // this.loadCompaniesData().then(() => {
    //   this.initFromUrl();
    // });
    this.initFromUrl();
  },
  computed: {
    isCopp() {
      return this.$store.getters.isCopp;
    },
    locations() {
      return this.$store.getters['shipment_md/orders/get_locations_data'];
    },
    orders() {
      return this.$store.getters['shipment_md/orders/orders'];
    },
    isNotEmpty() {
      return true;
    },
    prevDisabled() {
      return this.lastData === null;
    },
    nextDisabled() {
      return this.orders.length < 10;
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    isFiltered() {
      const filtered =
        !isEmpty(this.selectedCompany) ||
        !isEmpty(this.selectedCustomer) ||
        !isEmpty(this.selectedDestination) ||
        !isEmpty(this.currentSort);
      return filtered;
    },
    hasSelectedCustomer() {
      return !this.selectedCustomer || isEmpty(this.destinationList);
    },
    ordersGetters() {
      return this.$store.getters['shipment_md/orders/dataOrders'];
    },
    isLoading() {
      return this.ordersGetters === 'LOADING';
    },
    isFetched() {
      return this.ordersGetters === 'LOADED';
    },
  },
  watch: {
    searchQuery(newValue) {
      this.updateSearchQuery(this, newValue);
    },
    orders(data) {
      this.table.items.splice(0);
      data.forEach((d) => {
        this.table.items.push(d);
      });
    },
  },
  methods: {
    get,
    initFromUrl() {
      const { query } = this.$route;

      if (isString(query.company_id) && query.company_id !== undefined) {
        this.onSelectCompany(query.company_id, true);
      }

      if (isString(query.customer_id) && query.customer_id !== undefined) {
        this.onSelectCustomer(query.customer_id, true);
      }

      if (isString(query.destination_id) && query.destination_id !== undefined) {
        this.onSelectDestination(query.destination_id, true);
      }

      if (query.sort !== undefined) {
        this.onSelectSort(query.sort, true);
      }

      this.loadData();
    },
    resetPagination() {
      this.lastData = null;
      this.lastDataAr = [];
    },
    updateSearchQuery: throttle((context, searchTerm) => {
      const searchQuery = searchTerm.trim();
      context.resetPagination();
      context.$store.commit('shipment_md/orders/SET_QUERY_SEARCH', searchQuery);
      context.loadData();
    }, 500, {
      leading: false,
    }),
    getConfirmation(data) {
      return data.confirmations.find(c => c.key === 'customer') || {};
    },
    checkHasSignature(data) {
      const comfirmation = this.getConfirmation(data);
      const hasSignature = !isEmpty(comfirmation.signature);
      return hasSignature;
    },
    loadData() {
      this.dataBeforeLoad = cloneDeep(this.orders);
      this.$store.commit('shipment_md/orders/SET_QUERY_LAST_DATA', this.lastData);
      if (this.searchQuery.trim() !== '') {
        return this.$store.dispatch('shipment_md/orders/FIND_DATA');
      }
      return this.$store.dispatch('shipment_md/orders/LOAD_DATA');
    },
    prevPage() {
      this.lastDataAr.pop();
      if (this.lastDataAr.length) {
        this.lastData = last(this.lastDataAr);
      } else {
        this.lastData = null;
      }
      this.loadData();
    },
    nextPage() {
      const currSort = isEmpty(this.currentSort) ? '' : this.currentSort;
      const sortBy = head(currSort.split('.'));
      let lastDataKey = isEmpty(sortBy) ? 'id' : sortBy.toLowerCase();
      const skipBy = isEmpty(sortBy) ? 'ID' : sortBy;

      if (this.searchQuery.trim() !== '') {
        lastDataKey = 'number';
        this.$store.commit('shipment_md/orders/SET_SKIP_BY', 'NUMBER');
        this.$store.commit('shipment_md/orders/SET_QUERY_SORT', 'NUMBER.ASC');
      } else {
        this.$store.commit('shipment_md/orders/SET_SKIP_BY', skipBy);
      }

      const order = last(this.orders);
      this.lastDataAr.push(order[lastDataKey]);
      this.lastData = order[lastDataKey];
      this.loadData();
    },
    createOrder() {
      this.$store.commit('shipment_md/orders/CLEAR_SELECTED_VALUE');
      this.$router.push('/shipment_md/orders/create');
    },
    getDuration(metadata, source = 'gps') {
      const timeIn = this.getTimeIn(metadata, source);
      const timeOut = this.getTimeOut(metadata, source);
      const durationInMinutes = this.getDurationValueInMinutes(timeOut, timeIn);

      const minutesInADay = 1440;
      const isMoreThanOneDay = durationInMinutes > minutesInADay;
      const durationHumanize = isMoreThanOneDay ? 'more than 1day' : `${durationInMinutes} minutes`;

      return durationInMinutes > 0 ? durationHumanize : undefined;
    },
    getShipmentNumber(shipment) {
      if (isObject(shipment)) {
        return shipment.number;
      }
      return undefined;
    },
    getShipmentId(shipment) {
      if (isObject(shipment)) {
        return shipment.id;
      }
      return undefined;
    },
    getTimeIn(metadata, source = 'gps') {
      if (isObject(metadata)) {
        const sourceKey = source === 'gps' ? 'time_in' : 'time_in_app';
        return metadata[sourceKey] || '-';
      }
      return undefined;
    },
    getTimeOut(metadata, source = 'gps') {
      if (isObject(metadata)) {
        const sourceKey = source === 'gps' ? 'time_out' : 'time_out_app';
        return metadata[sourceKey] || '-';
      }
      return undefined;
    },
    onRemoveFilter() {
      const unSelectButtons = document.querySelectorAll('.ui-unselect--option');
      unSelectButtons.forEach((el) => {
        el.click();
      });
    },
    isObjectEmpty(object) {
      return isEmpty(object);
    },
    createSignature(data) {
      return `data:image/png;base64,${data}`;
    },
    onSelectCompany(newValue, fromInit = false) {
      const { query } = this.$route;
      const companyId = isObject(newValue) ? newValue.id || null : newValue;
      this.$store.commit('shipment_md/orders/SET_COMPANY_ID', companyId);
      this.selectedCompany = companyId;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            company_id: companyId,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['company_id']),
          },
        });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectCompany = companyId;
      }
    },
    onSelectCustomer(newValue, fromInit = false) {
      const { query } = this.$route;
      const customerId = isObject(newValue) ? newValue.id || null : newValue;
      this.$store.commit('shipment_md/orders/SET_CUSTOMER_ID', customerId);
      this.selectedCustomer = newValue;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            customer_id: customerId,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['customer_id']),
          },
        });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectCustomer = customerId;
      }

      this.destinationList.splice(0);
      this.destinationList = filter(this.locations, { company: { id: customerId } });
      if (!isEqual(customerId, get(this.selectedDestination, 'company.id'))) {
        this.selectedDestination = [];
      }
    },
    onSelectDestination(newValue, fromInit = false) {
      const { query } = this.$route;
      const destinationId = isObject(newValue) ? newValue.id || null : newValue;
      this.$store.commit('shipment_md/orders/SET_DESTINATION_ID', destinationId);
      this.selectedDestination = newValue;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            destination_id: destinationId,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['destination_id']),
          },
        });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectDestination = destinationId;
      }
    },
    onSelectSort(newValue, fromInit = false) {
      const { query } = this.$route;
      const sortValue = isObject(newValue) ? newValue.value || null : newValue;
      this.currentSort = sortValue;
      this.resetPagination();

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            sort: sortValue,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['sort']),
          },
        });
        return;
      }

      const { id } = this.sortOptions.find(s => s.value === sortValue);
      this.$store.commit('shipment_md/orders/SET_QUERY_SORT', sortValue);

      if (!fromInit) {
        this.loadData();
      } else {
        this.initSelectSort = id;
      }
    },
    loadCompaniesData() {
      return Promise.all([
        this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: 0 }),
        this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: 1 }),
      ]).then((data) => {
        const companies = data[0] || [];
        const customers = companies.filter(dt => dt.type === 'CUSTOMER');
        const tenants = data[1];
        this.companiesData = companies;
        this.customersData = !this.isSystemAdmin ? uniqBy(concat(customers, tenants), 'id') : companies;
      });
    },
  },
};
</script>
<style lang="sass">
.table td
  vertical-align: middle
.table-confirm-signature
  height: 80px
  margin: -0.5rem
.remove--filter
  font-weight: bold;
  cursor: pointer;
  color: #e66f6f;
.remove--filter
  i
    font-size: 17px;
.remove--filter:hover
  color: #0366d6;
@media screen and (max-width: 320px)
  .ui-dropdown-modal-holder
    width: 250px !important
</style>

<style lang="sass" scoped>
.show__loading
  height: 800px
  top: 75px
  width: 96.5%
  position: absolute
  opacity: 0.3
  background-color: #9E9E9E

  >img
    height: 50px
    width: 50px
    margin-left: 50%

.show__blur
  -webkit-filter: blur(1px)
  -moz-filter: blur(1px)
  -ms-filter: blur(1px)
  -o-filter: blur(1px)
  filter: blur(1px)

.fa-modify
  color: #000000;
  margin-left: 45%;
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/orders/List.vue